<template>
    <div>
      <Toolbar
        :handle-submit="onSendForm"
        :handle-reset="resetForm"
        :handle-delete="del"
        >
          <template slot="left">
            <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
              <h1><v-icon large>mdi-basket</v-icon>{{ item['name'] }}</h1>
            </v-toolbar-title>
          </template>
      </Toolbar>
      <OrderResolutionForm
        ref="updateForm"
        v-if="item"
        :values="item"
        :errors="violations"
      />
      <Loading :visible="isLoading || deleteLoading" />
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import OrderResolutionForm from '../../components/orderresolution/Form.vue';
  import Loading from '../../components/Loading';
  import Toolbar from '../../components/Toolbar';
  import UpdateMixin from '../../mixins/UpdateMixin';
  
  const servicePrefix = 'OrderResolution';
  
  export default {
    name: 'OrderResolutionUpdate',
    servicePrefix,
    mixins: [UpdateMixin],
    components: {
      Loading,
      Toolbar,
      OrderResolutionForm
    },
  
    computed: {
      ...mapFields('orderresolution', {
        deleteLoading: 'isLoading',
        isLoading: 'isLoading',
        error: 'error',
        updated: 'updated',
        violations: 'violations'
      }),
      ...mapGetters('orderresolution', ['find'])
  
    },
  
    methods: {
      ...mapActions('orderresolution', {
        deleteItem: 'del',
        retrieve: 'load',
        update: 'update',
      })
    }
  };
  </script>
  